import { render } from "./PageFooterSecond.vue?vue&type=template&id=1e16df3e&scoped=true"
import script from "./PageFooterSecond.vue?vue&type=script&lang=js"
export * from "./PageFooterSecond.vue?vue&type=script&lang=js"

import "./PageFooterSecond.vue?vue&type=style&index=0&id=1e16df3e&scoped=true&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e16df3e"]])

export default __exports__